import React, { useRef, useState } from 'react';
import { ModernButton } from '../ui/ModernButton';
import { QRCodeSVG } from 'qrcode.react';
import toast from 'react-hot-toast';

function svgToCanvas(svgElement, size) {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 0, 0);
      resolve(canvas);
    };
    img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgData);
  });
}

export function LinkModal({ link, onClose }) {
  const [copyText, setCopyText] = useState('Link kopieren');
  const [showQR, setShowQR] = useState(false);
  const qrRef = useRef(null);

  const handleQRCopy = async () => {
    const svg = qrRef.current?.querySelector('svg');
    if (!svg) return;
    try {
      const canvas = await svgToCanvas(svg, 200);
      canvas.toBlob(async (blob) => {
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
        toast.success('QR-Code kopiert!');
      }, 'image/png');
    } catch (err) {
      console.error('Fehler beim Kopieren des QR-Codes:', err);
    }
  };

  const handleQRDownload = async () => {
    const svg = qrRef.current?.querySelector('svg');
    if (!svg) return;
    try {
      const canvas = await svgToCanvas(svg, 200);
      const a = document.createElement('a');
      a.download = 'qr-code.png';
      a.href = canvas.toDataURL('image/png');
      a.click();
    } catch (err) {
      console.error('Fehler beim Herunterladen des QR-Codes:', err);
    }
  };

  const handleCopy = () => {
    const textArea = document.createElement("textarea");
    textArea.value = link;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      setCopyText('Kopiert!');
      setTimeout(() => setCopyText('Link kopieren'), 2000);
    } catch (err) {
      console.error('Fehler beim Kopieren: ', err);
    }
    document.body.removeChild(textArea);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-slate-800 dark:text-slate-200 p-8 rounded-2xl shadow-2xl max-w-md w-full m-4">
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-4">Fragebogen erstellt!</h2>
        <p className="text-slate-600 dark:text-slate-300 mb-6">Teile den folgenden Link mit den Bewerbern.</p>
        <div className="flex gap-2">
          <input type="text" value={link} readOnly className="w-full p-3 border border-slate-300 dark:border-slate-700 rounded-lg bg-slate-50 dark:bg-slate-900 dark:text-slate-200" />
          <ModernButton onClick={handleCopy} variant="success" size="md" className="w-40">
            {copyText}
          </ModernButton>
        </div>
        <div className="mt-4 border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden">
          <button
            onClick={() => setShowQR(!showQR)}
            className="w-full flex items-center justify-between p-3 text-sm font-medium text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors"
          >
            <span>QR-Code anzeigen</span>
            <svg className={`w-4 h-4 transition-transform duration-200 ${showQR ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {showQR && (
            <div className="flex flex-col items-center gap-3 p-4 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
              <div
                ref={qrRef}
                onClick={handleQRCopy}
                className="cursor-pointer hover:opacity-80 transition-opacity"
                title="Klicken zum Kopieren"
              >
                <QRCodeSVG value={link} size={200} level="M" />
              </div>
              <p className="text-xs text-slate-400 dark:text-slate-500">Klicken zum Kopieren</p>
              <ModernButton onClick={handleQRDownload} variant="secondary" size="sm">
                Download PNG
              </ModernButton>
            </div>
          )}
        </div>
        <ModernButton onClick={onClose} variant="secondary" size="lg" className="mt-6 w-full">
          Schließen
        </ModernButton>
      </div>
    </div>
  );
}
